import store from '@/store';
import { App } from 'vue';

export type Listener = (isDemo: boolean) => void;
export type SubscriptionExpiredListener = (isExpired: boolean) => void;

let listeners: Listener[] = [];
let subscriptionExpiredListeners: SubscriptionExpiredListener[] = [];

export const isDemoCompany = () => {
   return Boolean(store.getters.currentCompany?.is_demo);
};

export const whenIsDemoCompany = (callback: Listener) => {
   if (typeof callback != 'function') {
      return console.error('whenIsDemoCompany parameter must be a function', { callback });
   }

   listeners.push(callback);
};

export const whenIsSubscriptionExpired = (callback: SubscriptionExpiredListener) => {
   if (typeof callback != 'function') {
      return console.error('whenIsSubscriptionExpired parameter must be a function', { callback });
   }

   subscriptionExpiredListeners.push(callback);
};

export const callListeners = (isDemo: boolean) => {
   listeners.forEach((listener) => {
      if (typeof listener == 'function') listener(isDemo);
   });

   listeners = [];
};

export const callSubscriptionExpiredListeners = (isExpired: boolean) => {
   subscriptionExpiredListeners.forEach((listener) => {
      if (typeof listener == 'function') listener(isExpired);
   });

   subscriptionExpiredListeners = [];
};

export const DemoCompanyPlugin = {
   install: (app: App<Element>) => {
      app.config.globalProperties.$isDemoCompany = isDemoCompany;
      app.config.globalProperties.$whenIsDemoCompany = whenIsDemoCompany;
   },
};
